<template>
    <div class="feedback-icon">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 404.63 400.19" style="enable-background:new 0 0 404.63 400.19;" xml:space="preserve">

        <g>
            <path class="st0" :stroke="colors.theme == 'dark' ? '#fff' : '#000'" d="M218.64,57.64l-30.17,279.32l52.36,7.16l20.27,46.8l34.27-38.45l70.01,10.79l30.18-279.32L218.64,57.64z
                M310.3,291l-0.28,2.16c-1.98,15.5-16.15,26.46-31.65,24.47l-2.16-0.28c-15.5-1.98-26.46-16.15-24.47-31.65l0.28-2.16
                c1.98-15.5,16.15-26.46,31.65-24.47l2.16,0.28C301.32,261.33,312.28,275.5,310.3,291z M335.23,125.8l-12.53,97.94
                c-1.98,15.5-16.15,26.46-31.65,24.47l-2.51-0.32c-15.5-1.98-26.46-16.15-24.47-31.65l12.53-97.94
                c1.98-15.5,16.15-26.46,31.65-24.47l2.51,0.32C326.25,96.13,337.21,110.31,335.23,125.8z"/>
            <path class="st0" :stroke="colors.theme == 'dark' ? '#fff' : '#000'" d="M13.57,9.45l-1.2,155.45l173.25,2.72l1.2-155.45L13.57,9.45z M165.27,62.7l-70.49,72.91
                c-7.07,7.31-18.66,7.71-26.21,0.9l-32.21-29.02c-6.74-6.07-7.28-16.46-1.21-23.2l0,0c6.07-6.74,16.46-7.28,23.2-1.21l22.18,19.98
                l61.11-63.2c6.31-6.52,16.71-6.7,23.23-0.39C171.41,45.77,171.58,56.17,165.27,62.7z"/>
            <path class="st0" :stroke="colors.theme == 'dark' ? '#fff' : '#000'" d="M153.06,192.08L10.83,205.87l10.85,132.57l42.99-3.62l34.12,24.46l26.89-30.93l38.23-3.71L153.06,192.08z
                M130.07,297.7L130.07,297.7c-4.8,6.48-13.94,7.84-20.42,3.05l-18.38-13.61l-13.61,18.38c-4.8,6.48-13.94,7.84-20.42,3.05h0
                c-6.48-4.8-7.84-13.94-3.05-20.42l13.61-18.38l-18.38-13.61c-6.48-4.8-7.84-13.94-3.05-20.42l0,0c4.8-6.48,13.94-7.84,20.42-3.05
                l18.38,13.61l13.61-18.38c4.8-6.48,13.94-7.84,20.42-3.05l0,0c6.48,4.8,7.84,13.94,3.05,20.42l-13.61,18.38l18.38,13.61
                C133.5,282.07,134.87,291.22,130.07,297.7z"/>
        </g>
        </svg>

    </div>
</template>

<script>

export default {  
    props:["fill"],
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
        // console.log('Colors: ', this.colors)
    }
}
</script>
<style lang="scss" scoped>
.feedback-icon{
    width: 215px;

    .fill-transparent{
        fill: transparent !important
    }
}
</style>
<style type="text/css" scoped>
    .st0{fill:none;stroke-width:5;stroke-miterlimit:10;}
</style>

